import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  inject,
} from '@angular/core';
// Lazy load images in-view as you scroll
// Only for big lists eg: syndicates list & tickets

import { CB_UI_ENV } from '../../environment/cb-ui-env.token';

@Directive({
  selector: 'img[imgLazyLoad]',
  standalone: true,
})
export class ImagesLazyLoadDirective implements AfterViewInit, OnDestroy {
  @HostBinding('attr.src') srcAttr: string | null = null;
  @Input() src!: string; // Always bound by real consumers
  private _env = inject(CB_UI_ENV);
  private observer?: IntersectionObserver;

  constructor(
    public el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    if (this._env.web) {
      this.el.nativeElement.src = this.src;
    } else {
      this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage();
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private canLazyLoad() {
    return window && 'IntersectionObserver' in window;
  }

  private lazyLoadImage() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.loadImage();
          this.observer?.unobserve(this.el.nativeElement);
        }
      });
    });
    this.observer.observe(this.el.nativeElement);
  }

  private loadImage() {
    this.srcAttr =
      this.src && this.src.includes('https') ? this.src : `https:${this.src}`;
    this.cdr.detectChanges();
  }
}
